export const contextPath = () => (typeof window !== 'undefined' ? window.contextPath || '' : '')

export const restEndpoint = (path: string) => `${contextPath()}/.rest/${path}`
export const newsRestEndpoint = () => restEndpoint('news')

const breakpoints = {
    desktop: 1024
}

export const lang = () => {
    return location.pathname
        .replace(contextPath(), '')
        .split('/')
        .filter(x => x.length)
        .shift()
}

export const dataLayerPush = (payload: unknown) => {
    if (window.dataLayer) {
        const dataLayer = window.dataLayer || [];
        dataLayer.push(payload);
    }
}


export const checkIsMobile = () => {
    return window.innerWidth < breakpoints.desktop
}
